export default __webpack_public_path__ + "static/media/thaigo-screenshot-03.73fb2f5a.png";